var utils = require("../utils");
var config = require("../config");

var jsErrorLogger = {};
var name = "jsErrorLogger";
var type = 1;

function say(msg){
    utils.log(name+" : "+msg);
}

/*
报错样例:
window.onerror函数调用的参数顺序如下:
Arguments[5]
0:"Uncaught ReferenceError: plupload is not defined"    -msg
1:"http://m.guba.eastmoney.com/js/newpost.js?v=0.06"    -file_loc
2:265   -line_no
3:22    -col_no
4:ReferenceError: plupload is not defined at init_uploader (http://m.guba.eastmoney.com/js/newpost.js?v=0.06:265:22) at init_upload_image (http://m.guba.eastmoney.com/js/newpost.js?v=0.06:262:2) at HTMLDocument.<anonymous> (http://m.guba.eastmoney.com/js/newpost.js?v=0.06:117:2) at l (http://m.guba.eastmoney.com/js/jquery-1.8.3.min.js:2:16996) at Object.fireWith [as resolveWith] (http://m.guba.eastmoney.com/js/jquery-1.8.3.min.js:2:17783) at Function.ready (http://m.guba.eastmoney.com/js/jquery-1.8.3.min.js:2:12504) at HTMLDocument.A (http://m.guba.eastmoney.com/js/jquery-1.8.3.min.js:2:9909)
callee:(msg, file_loc, line_no, col_no)
length:5
Symbol(Symbol.iterator):values()
__proto__:Object
 */

//私有函数
//发送到服务器
function sendError(file_loc, line_no, col_no, msg, stack) {
    try {
        // format the data for the request
        //var param = "";//config.url + "?i=" + i;            //index
        //param += "&sn=" + escape(url);                        //页面URL
        var param = {};
        param.res_url = utils.encode(file_loc);                   //脚本URL
        param.ln = line_no;                    //出错行号
        param.cn = (typeof col_no === "undefined") ? "" : col_no;//出错列号
        param.msg = msg?utils.encode(msg.substr(0, 256)):"";  //为了限制url总长度
        param.stack = stack?utils.encode(stack.substr(0, 1000)):"";//防止自定义信息过长,限定256,毕竟是get
        
        param.xt=type;        //xtype 日志类型

        console.log(param)
        // 检查是否达到每页的最大报错数量
        if (config.maxRep > 0 || config.maxRep === false) {
            if (config.maxRep > 0) {
                    config.maxRep -= 1;
            }
            utils.requestRemote(param);
        }
    } catch (e) {
        utils.errorHandler("sendError", e,name);
    }
}

//错误处理函数
function handleError(msg, file_loc, line_no, col_no, stack) {
    if (config.domainWhitelist.length > 0) {
        if (utils.matchDomains(file_loc,config.domainWhitelist) === false){
            console.log("jsErrorLogger - report ignored because " + file_loc + " did not match the whitelist" );
            return;
        }
    }

    if (config.domainIgnore.length > 0) {
        if (utils.matchDomains(file_loc,config.domainIgnore) === true){
            console.log("jsErrorLogger - report ignored because " + file_loc + " matched the blacklist" );
            return;
        }
    }

    if (config.ignoreCrossOriginErrors && msg == "Script Error" && line_no == "0") {
        console.log("jsErrorLogger - cross origin script error ignored because no additional error info supplied.");
        return;
    }

    // 是否需要忽略页面url参数
    var url = document.URL;
    if (config.qsIgnore.length > 0) {
        url = utils.stripQueries( window.location, config.qsIgnore);

        // file_loc也过滤一下get参数
        // (in some cases, like an explicitly thrown exception, fileloc might be empty)
        if (typeof file_loc !== "undefined" && file_loc.length > 1) {

            file_loc = utils.stripQueries( utils.parseURL(file_loc),config.qsIgnore );

        }
    }
    //发到服务器
    sendError(file_loc, line_no, col_no, msg, stack);

    return true;
}

jsErrorLogger.handleError=function(event){
  try {
    if(event && event.target==window && event.error && event.error.stack ){//ie9以下无效
        say("handleError "+event)

        var lineno = event.lineno>=0?event.lineno:-1
        var colno = event.colno>=0?event.colno:-1
        var stack = event.error && event.error.stack?event.error.stack:''

        handleError(event.message, event.filename, lineno, colno, stack)

        return true
    }
  }
  catch(e){
    say(e)
  }
  return false
}

/**
 * 手动导出开启函数
 * @return {[type]} [description]
 */
jsErrorLogger.launch=function(){
    // if (window.scriptError) return;

    //做下低版本浏览器兼容
    // if( !Array.prototype.indexOf )
    // {
    //     Array.prototype.indexOf = function( element ){
    //         for( var i=0, ilen=this.length; i<ilen; i++ ){
    //             if( this[i] == element ) return i;
    //         }
    //         return -1;
    //     };
    // }
    // 
    // var scripts = document.getElementsByTagName('script');
    // // 获取现在已经加载的所有script
    // if(scripts.length>0)
    // {
    //     var len = scripts.length
    //     for(var i=0;i<len;++i){
    //         var script = scripts[i]
    //         // script.crossOrigin='anonymous'
    //         script.setAttribute('crossorigin', 'anonymous');
    //     }
    // }

    // 老版本(IE浏览器不用报错)
    // 先保存原来的onerror
    // 重写我们的onerror
    if(!window.ErrorEvent && !utils.isIE()){
        jsErrorLogger.fnPreviousOnErrorHandler = window.onerror;
        window.onerror = function(msg, file_loc, line_no, col_no){
            say("onerror "+event)
            handleError(msg, file_loc, line_no, col_no);
            if(typeof(jsErrorLogger.fnPreviousOnErrorHandler) == "function") {
                // 原onerror调用一下
                jsErrorLogger.fnPreviousOnErrorHandler(msg, file_loc, line_no, col_no);
            }
            return config.trapErrors;
        }        
    }



}

module.exports = jsErrorLogger;


//////////////////
// WEBPACK FOOTER
// ./src/logger/jsErrorLogger.js
// module id = 3
// module chunks = 0 1 2